
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news_detail/[newsId]",
      function () {
        return require("private-next-pages/media/news_detail/[newsId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/news_detail/[newsId]"])
      });
    }
  